import registerColumn from '../../../common/columns/index';
import presentationalComponent from './ColumnPresentationalWrapper';
import containerComponent from './ColumnContainer';

import { isApple } from '../../utils/services/browser';

import { TOOLS } from '../../workspace/toolbar/toolbarConstants';

export default () =>
    registerColumn({
        presentationalComponent,
        containerComponent,
        tools: [TOOLS.COLOR],
        tooltip: isApple ? '⌃⌘G' : 'Ctrl+Alt+G',
    });
